export default {
  "content": "<path d=\"M10 6.67a1.67 1.67 0 110-3.34 1.67 1.67 0 010 3.34zm0 5a1.67 1.67 0 110-3.34 1.67 1.67 0 010 3.34zM8.33 15a1.67 1.67 0 103.34 0 1.67 1.67 0 00-3.34 0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "fill": "#fff",
    "viewBox": "0 0 20 20"
  }
};